import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './connections.less';
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import { notify } from 'common/Notification';

export default class CalendarFeedSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
  };

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId === null) {
      this.setState({ loading: true});

      // TODO need to deal with calendar_feed_id somehow
      this.props.dispatch(connectIntegration('calendar','calendar',null));
      this.setState({ loading: false });
    }
    else {
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <h2 className="calendar-switch"><i className="fa fa-calendar"></i> Bankruptcy Calendar Feed</h2>

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}
          />}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Integrations/connections/CalendarFeedSwitch.jsx